import React from 'react';

import Button from '@ad-scripts/presentation/components/common/button';
import OverflowMenu, {
  OverflowMenuButton,
  OverflowMenuItem,
  OverflowMenuLink,
  usePopoverMenu,
} from 'src/presentation/components/pages/shared/OverflowMenu';
import analytics from '@ad-scripts/lib/analytics';
import { EmailAddress } from 'src/models/Email/EmailAddress';

type EmailAddressRowActionsType = {
  item: EmailAddress;
  onEditSenderName: (EmailAddress: EmailAddress) => void;
  onViewForwardingEmailAddress: (emailAddress: EmailAddress) => void;
  root: string;
};

const EmailAddressRowActions = ({ item, onViewForwardingEmailAddress, root }: EmailAddressRowActionsType) => {
  const { onClose, ...popoverMenuProps } = usePopoverMenu();

  const handleViewForwardingEmailAddress = () => {
    analytics.track('Email Address - open View forwarding email address', {
      id: item.id,
      address: item.address,
    });
    onClose();
    onViewForwardingEmailAddress(item);
  };

  return (
    <OverflowMenu id={item.id} onClose={onClose} {...popoverMenuProps}>
      <OverflowMenuItem id={`edit-${item.id}`}>
        <OverflowMenuLink data-aid="edit-configuration-button" to={`${root}/${item.id}`}>
          Edit configuration
        </OverflowMenuLink>
      </OverflowMenuItem>

      <OverflowMenuItem id="view-forwarding-email-address">
        <OverflowMenuButton
          data-aid="view-forwarding-email-address"
          type={Button}
          onClick={handleViewForwardingEmailAddress}
        >
          View forwarding email address
        </OverflowMenuButton>
      </OverflowMenuItem>
    </OverflowMenu>
  );
};

export default EmailAddressRowActions;
